import { ComponentPreloader } from 'components/ComponentPreloader';
import { SSRMediaQuery } from 'components/SSRMediaQuery';
import { BREAKPOINTS } from 'constants/grid';
import HeaderLogo from 'components/HeaderLogo';
import classNames from 'classnames';
import React from 'react';
import { useMinSpend } from 'hooks/use-min-spend';
import LoginLink from 'components/AuthenticationAction/LoginLink';
import SlideOutNav from '../SlideOutNav';
import { nonDesktopPageLoadPreloadComponents } from '../SiteHeader';
import styles from './index.scss';
import ShoppingSummary from './ShoppingSummary';
import MobileSearchButton from './MobileSearchButton';
import SlotButton from './SlotButton';

export const MobileHeader = ({ isLoggedIn, toggleOverlay }) => {
  const SignInOrTrolley = isLoggedIn ? (
    <ShoppingSummary isMobile />
  ) : (
    <LoginLink data-testid="mobileHeaderSigninLink">Sign in</LoginLink>
  );

  const { showMinSpend } = useMinSpend();

  return (
    <SSRMediaQuery maxWidth={BREAKPOINTS.md}>
      <ComponentPreloader components={nonDesktopPageLoadPreloadComponents} />
      <div className={classNames('container-fluid', styles.container)}>
        <div className={styles.mobileMenu}>
          <SlideOutNav />
        </div>
        <div
          className={classNames(styles.mobileLogo, {
            [styles.hasMinSpend]: showMinSpend,
          })}
        >
          <HeaderLogo small />
        </div>
        <div
          className={classNames(styles.mobileInner, {
            [styles.hasMinSpend]: showMinSpend,
          })}
        >
          <div className={styles.mobileSearch}>
            <MobileSearchButton toggleOverlay={toggleOverlay} />
          </div>
          <div className={styles.mobileSlot}>
            <SlotButton isMobile testId="mobile" textOnly shortTime />
          </div>
          <div
            className={classNames(styles.signInOrTrolley, {
              [styles.hasMinSpend]: showMinSpend,
            })}
          >
            {SignInOrTrolley}
          </div>
        </div>
      </div>
    </SSRMediaQuery>
  );
};
